import { RouterState } from '@frontend-site/shared/router-store';

const SYSTEM_PATH_PREFIX = ['myERPs', 'enterSystem', 'systemSetup'];

export function isSystemScope(state: RouterState): boolean {
    const systemId = state.params?.['systemId'];
    const url = state['url'];
    return !!systemId || SYSTEM_PATH_PREFIX.some((segment) => url.includes(segment));
}
